import type { AIModel } from "@/features/ai-model-selection/store/ai-model-store";
import { modelsPaths } from "@/modules";

export interface OpenWizardAssistantPayload {
  model: AIModel;
  source?: "creative-generation" | string;
  messageId?: string;
  initialMessage?: string;
  models?: AIModel[];
  chatId?: string;
  navigate?: (path: string) => void;
}

// ✅ Updated to use navigation instead of wizard store
export const openWizardFromAssistantPayload = (
  payload: OpenWizardAssistantPayload
) => {
  try {
    // Navigate to wizard page with optional chatId
    if (payload.navigate) {
      const chatIdParam = payload.chatId ? `/${payload.chatId}` : "";
      payload.navigate(`${modelsPaths.wizard(payload.model._id)}${chatIdParam}`);
    } else {
      console.warn(
        "Navigate function not provided to openWizardFromAssistantPayload"
      );
    }
  } catch (error) {
    console.error("Error opening wizard:", error);
  }
};
